import React, { useEffect, useRef, useState } from "react";
import Maincontent from "../../components/dashboard/maincontent";
import Rightsidebar from "../../components/dashboard/rightsidebar";
import { useDispatch, useSelector } from "react-redux";
import { getGData } from "../../redux/slices/ggame";
import { useNavigate } from "react-router-dom";
import CircularProgressWithLabel from "../../components/loading";

function Games() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, loading } = useSelector((g) => g?.games);
  const isFirstCall = useRef(true);
  const user = useSelector((val) => val?.login?.user?.id);
  useEffect(() => {
    if (isFirstCall.current) {
      dispatch(getGData());
      isFirstCall.current = false;
    }
  }, [dispatch]);

  if (loading) {
    return <CircularProgressWithLabel />;
  }

  return (
    <>
      <Maincontent data={data?.usergames} rgames={data?.remainggames} />
      <Rightsidebar data={data?.remainggames} />
      {/* <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-[#3e0534] to-[#3e0433] text-white flex justify-around p-3 sm:hidden z-50 shadow-lg">
        <button
          className="flex flex-col items-center w-[20%] text-[#c4b6c1]"
          aria-label="Purchase"
          onClick={() => navigate("/purchase")} 
        >
          <PaymentsOutlinedIcon />
          <span className="text-[10px]">Purchase</span>
        </button>
        <button
          className="flex flex-col items-center w-[20%] text-[#c4b6c1]"
          aria-label="Cashout"
          onClick={() => navigate("/cashout")} 
        >
          <MonetizationOnOutlinedIcon />
          <span className="text-[10px]">Cashout</span>
        </button>
        <button
          className="flex flex-col items-center w-[20%] text-[#dfc7da] text-[20px] mt-[-8px]"
          aria-label="Main"
          onClick={() => navigate("/dashboard")} 
        >
          <img
            className="w-[30px]"
            src="/images/homeicon.png"
            alt="home-icon"
          />
          <span className="text-[13px]">Home</span>
        </button>
        <button
          className="flex flex-col items-center w-[20%] text-[#c4b6c1] mt-0"
          aria-label="Game"
          onClick={() => navigate("/profile")} 
        >
          <AccountCircleOutlinedIcon />
          <span className="text-[10px]">Profile</span>
        </button>

          <button
            className="flex flex-col items-center w-[20%] text-[#dfc7da]"
            aria-label="More"
            onClick={() => setShowMoreMenu(!showMoreMenu)}
          >
           < MoreHorizOutlinedIcon/>
            <span className="text-[10px] text-[#c4b6c1]">More</span>
          </button>
          {showMoreMenu && (
            <div className="absolute bottom-full left-0 w-full bg-white text-black  z-50 shadow-md">
              <div className="flex flex-col items-start divide-y divide-gray-300">
                <Link
                  to="/marketplace"
                  className="flex items-center text-black px-4 py-3 hover:text-gray-600 w-full"
                  aria-label="Marketplace"
                >
                 <SportsEsportsOutlinedIcon />
                  <span className="pl-2">Games</span>
                </Link>
                <Link
                  to="/roulette"
                  className="flex items-center text-black px-4 py-3 hover:text-gray-600 w-full"
                  aria-label="Roulette"
                >
                  <HistoryOutlinedIcon />
                  <span className="pl-2">History</span>
                </Link>
                <Link
                  to="/draw"
                  className="flex items-center text-black px-4 py-3 hover:text-gray-600 w-full"
                  aria-label="Draw"
                >
                  <PowerSettingsNewOutlinedIcon />
                  <span className="pl-2">Logout</span>
                </Link>
              </div>
            </div>
         
        )}
      </div> */}
    </>
  );
}

export default Games;
